import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap"
import { TableCell, TableRow } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import axios from "axios";
import Swal from "sweetalert2";
import PhoneClinicGrid from "../../../Components/PhoneClinicGrid";
import RowActions from "../../../Components/PhoneClinicGrid/RowActions";
import { formatAmount } from './../../../helper';

import AmountInput from '../../../Components/AmountInput';
import FormCard from '../shared/FormCard';
/* Customer Setup.
 *
 * Restores legacy Warehouse/CustomerSetup.aspx (table MS_Setup_Customer; procs
 * SP_MS_CustomerSetup_Insert / _Query / _Delete). Legacy rendered this as an inline-editable
 * Telerik grid; here it follows the app's own PhoneClinicGrid + toggled-form convention, as
 * Setup/ItemCategory.js does.
 *
 * Fields and the two required-field messages match legacy exactly. Legacy's COAccountID_FK is
 * intentionally absent — it referenced a chart of accounts the rewrite does not have, and the
 * legacy page had no editor for it either.
 */

class CustomerSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CustomerList: [],
            addCustomer: false,
            PC_CUST_ID: "",
            PC_CUST_CODE: "",
            PC_CUST_NAME: "",
            PC_CUST_CONTACT_PERSON: "",
            PC_CUST_CONTACT: "",
            PC_CUST_CONTACT2: "",
            PC_CUST_EMAIL: "",
            PC_CUST_ADD: "",
            PC_CUST_OPEN_BAL: "0",
            PC_CUST_OB_DATE: "",
            PC_CUST_ACTIVE: "1"
        };
        this.gridRef = React.createRef(null);
    }

    async getCustomerList(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader && this.props.toggleLoader(true)
        try {
            const formData = {
                searchData,
                totalRecordsPerPage: pagination.pageSize,
                recordOffset: pagination.recordOffset
            };
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Setups/Customer.php`, formData);
            const resp = res.data
            let CustomerList = []
            if (resp.success === 1) {
                CustomerList = resp.data
                pagination.totalItems = parseInt(resp.Page_count[0]['TOTAL_PAGE_COUNT'])
                pagination.totalPages = Math.ceil(pagination.totalItems / (pagination.pageSize || 50))
                this.gridRef.current?.setPaginationData(pagination)
            }
            this.setState({ CustomerList })
        } catch (error) {
            console.error('getCustomerList error :>> ', error);
            this.setState({ CustomerList: [] })
        }
        this.props.toggleLoader && this.props.toggleLoader(false)
    }

    handleAddCustomer() {
        this.setState({ addCustomer: true })
    }

    handleChangeInput(fieldName, event) {
        this.setState({ [fieldName]: event.target.value })
    }

    handleExit() {
        this.setState({
            addCustomer: false,
            PC_CUST_ID: "",
            PC_CUST_CODE: "",
            PC_CUST_NAME: "",
            PC_CUST_CONTACT_PERSON: "",
            PC_CUST_CONTACT: "",
            PC_CUST_CONTACT2: "",
            PC_CUST_EMAIL: "",
            PC_CUST_ADD: "",
            PC_CUST_OPEN_BAL: "0",
            PC_CUST_OB_DATE: "",
            PC_CUST_ACTIVE: "1"
        })
    }

    async handleSubmitCustomer() {
        // Validated here as well as server-side so the user isn't made to round-trip for it.
        // Wording matches legacy's own messages.
        if (this.state.PC_CUST_CODE.trim() === "") {
            Swal.fire('Error', 'Please Fill Customer Code', 'error')
            return
        }
        if (this.state.PC_CUST_NAME.trim() === "") {
            Swal.fire('Error', 'Please Fill Customer Name', 'error')
            return
        }

        this.props.toggleLoader && this.props.toggleLoader(true)
        try {
            const formData = {
                PC_CUST_ID: this.state.PC_CUST_ID,
                PC_CUST_CODE: this.state.PC_CUST_CODE,
                PC_CUST_NAME: this.state.PC_CUST_NAME,
                PC_CUST_CONTACT_PERSON: this.state.PC_CUST_CONTACT_PERSON,
                PC_CUST_CONTACT: this.state.PC_CUST_CONTACT,
                PC_CUST_CONTACT2: this.state.PC_CUST_CONTACT2,
                PC_CUST_EMAIL: this.state.PC_CUST_EMAIL,
                PC_CUST_ADD: this.state.PC_CUST_ADD,
                PC_CUST_OPEN_BAL: this.state.PC_CUST_OPEN_BAL,
                PC_CUST_OB_DATE: this.state.PC_CUST_OB_DATE,
                PC_CUST_ACTIVE: this.state.PC_CUST_ACTIVE,
                PC_CUST_BY: localStorage.getItem('PC_USR_NAME') || ""
            }
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/Setups/Customer.php`, formData);
            if (res.data.success === 1) {
                this.handleExit()
                this.getCustomerList()
            } else {
                // Duplicate code and the required-field checks come back here.
                Swal.fire('Error', res.data.message || 'Could not save the customer.', 'error')
            }
        } catch (error) {
            console.error('handleSubmitCustomer error :>> ', error);
            Swal.fire('Error', 'Could not save the customer.', 'error')
        }
        this.props.toggleLoader && this.props.toggleLoader(false)
    }

    handleEdit(indx) {
        const c = this.state.CustomerList[indx]
        this.setState({
            PC_CUST_ID: c.PC_CUST_ID,
            PC_CUST_CODE: c.PC_CUST_CODE || "",
            PC_CUST_NAME: c.PC_CUST_NAME || "",
            PC_CUST_CONTACT_PERSON: c.PC_CUST_CONTACT_PERSON || "",
            PC_CUST_CONTACT: c.PC_CUST_CONTACT || "",
            PC_CUST_CONTACT2: c.PC_CUST_CONTACT2 || "",
            PC_CUST_EMAIL: c.PC_CUST_EMAIL || "",
            PC_CUST_ADD: c.PC_CUST_ADD || "",
            PC_CUST_OPEN_BAL: c.PC_CUST_OPEN_BAL != null ? String(c.PC_CUST_OPEN_BAL) : "0",
            PC_CUST_OB_DATE: c.PC_CUST_OB_DATE || "",
            PC_CUST_ACTIVE: String(c.PC_CUST_ACTIVE) === "0" ? "0" : "1",
            addCustomer: true
        })
    }

    async handleDelete(indx) {
        const c = this.state.CustomerList[indx]
        const confirm = await Swal.fire({
            title: 'Delete customer?',
            text: `${c.PC_CUST_NAME} (${c.PC_CUST_CODE}) will be removed.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            confirmButtonColor: '#a32f2f'
        })
        if (!confirm.isConfirmed) return

        this.props.toggleLoader && this.props.toggleLoader(true)
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/delete/setup/DeleteCustomer.php`, {
                PC_CUST_ID: c.PC_CUST_ID
            });
            if (res.data.success === 1) {
                this.getCustomerList()
            } else {
                // The endpoint refuses to delete a customer that warehouse sales point at and
                // says how many — surface that verbatim rather than a generic failure.
                Swal.fire('Cannot delete', res.data.message || 'Could not delete the customer.', 'info')
            }
        } catch (error) {
            console.error('handleDelete error :>> ', error);
            Swal.fire('Error', 'Could not delete the customer.', 'error')
        }
        this.props.toggleLoader && this.props.toggleLoader(false)
    }

    render() {
        return (
            <Container>
                {this.state.addCustomer === false ?
                    <PhoneClinicGrid
                        title="CUSTOMER"
                        buttonLabel="Add Customer"
                        getData={this.getCustomerList.bind(this)}
                        onClickButton={this.handleAddCustomer.bind(this)}
                        isEditable={true}
                        ref={this.gridRef}
                        tableHeadData={[
                            { label: "CODE", isHidden: false },
                            { label: "NAME", isHidden: false },
                            { label: "CONTACT PERSON", isHidden: false },
                            { label: "CONTACT", isHidden: false },
                            { label: "EMAIL", isHidden: false },
                            { label: "OPENING BAL", isHidden: false },
                            { label: "ACTIVE", isHidden: false },
                        ]}
                    >
                        {this.state.CustomerList.map((c, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                <TableCell align='left'>{c.PC_CUST_CODE}</TableCell>
                                <TableCell align='left'>{c.PC_CUST_NAME}</TableCell>
                                <TableCell align='left'>{c.PC_CUST_CONTACT_PERSON}</TableCell>
                                <TableCell align='left'>{c.PC_CUST_CONTACT}</TableCell>
                                <TableCell align='left'>{c.PC_CUST_EMAIL}</TableCell>
                                <TableCell align='right'>{formatAmount(c.PC_CUST_OPEN_BAL)}</TableCell>
                                <TableCell align='center'>
                                    <Checkbox style={{ padding: "0px" }} size="small"
                                        checked={String(c.PC_CUST_ACTIVE) === "1"} disabled />
                                </TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                        { type: 'delete', onClick: this.handleDelete.bind(this, idx) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                    :
                    <>
                        <FormCard title={this.state.PC_CUST_ID === "" ? 'Add Customer' : 'Edit Customer'} mode={this.state.PC_CUST_ID === "" ? 'new' : 'edit'}
                            onCancel={this.handleExit.bind(this)}
                            onSave={this.handleSubmitCustomer.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Customer Code <span style={{ color: '#a32f2f' }} >*</span></Form.Label>
                                    <Form.Control
                                        value={this.state.PC_CUST_CODE}
                                        name="PC_CUST_CODE"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_CODE")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={5}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Customer Name <span style={{ color: '#a32f2f' }} >*</span></Form.Label>
                                    <Form.Control
                                        value={this.state.PC_CUST_NAME}
                                        name="PC_CUST_NAME"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_NAME")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Contact Person</Form.Label>
                                    <Form.Control
                                        value={this.state.PC_CUST_CONTACT_PERSON}
                                        name="PC_CUST_CONTACT_PERSON"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_CONTACT_PERSON")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Primary Contact No</Form.Label>
                                    <Form.Control
                                        value={this.state.PC_CUST_CONTACT}
                                        name="PC_CUST_CONTACT"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_CONTACT")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Secondary Contact No</Form.Label>
                                    <Form.Control
                                        value={this.state.PC_CUST_CONTACT2}
                                        name="PC_CUST_CONTACT2"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_CONTACT2")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={this.state.PC_CUST_EMAIL}
                                        name="PC_CUST_EMAIL"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_EMAIL")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Company Address</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        value={this.state.PC_CUST_ADD}
                                        name="PC_CUST_ADD"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_ADD")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Opening Balance</Form.Label>
                                    <AmountInput
                                        step="0.01"
                                        value={this.state.PC_CUST_OPEN_BAL}
                                        name="PC_CUST_OPEN_BAL"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_OPEN_BAL")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Opening Balance Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={this.state.PC_CUST_OB_DATE}
                                        name="PC_CUST_OB_DATE"
                                        onChange={this.handleChangeInput.bind(this, "PC_CUST_OB_DATE")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} style={{ alignSelf: 'center' }} >
                                <Form.Group className="mb-3" >
                                    <Form.Label>Active</Form.Label>
                                    <div>
                                        <Checkbox
                                            size="small"
                                            checked={this.state.PC_CUST_ACTIVE === "1"}
                                            onChange={(e) => this.setState({ PC_CUST_ACTIVE: e.target.checked ? "1" : "0" })}
                                        />
                                        <span style={{ fontSize: '12px', color: '#666' }} >
                                            Inactive customers stay on historic sales but leave the pickers.
                                        </span>
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        </FormCard>
                    </>
                }
            </Container>
        );
    }
}

export default CustomerSetup;
